"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetPromoSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const constants_1 = require("@dzambalaorg/constants");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_1 = require("../../../types");
const AssetPromoSection = ({ service }) => {
    const isProd = process.env.NODE_ENV === constants_1.NodeEnv.production;
    if (service === types_1.ServiceType.ADMIN && isProd) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { sx: { mb: 2 }, children: (0, jsx_runtime_1.jsx)(ui_kit_1.List, { component: "nav", subheader: (0, jsx_runtime_1.jsx)(ui_kit_1.List.Subheader, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.dashboard.mechanics.promo" }) }), children: (0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemButton, { component: react_router_dom_1.Link, to: "/promos", children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemIcon, { children: (0, jsx_runtime_1.jsx)(icons_material_1.AccessTime, {}) }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.promo.title" }) })] }) }) }));
};
exports.AssetPromoSection = AssetPromoSection;
//# sourceMappingURL=promo.js.map